import { PaymentType } from "../../administration"
import { DeliveryStatus } from "../../deliveries"
import { PaymentStatus } from "../../operations"
import { Customer, HoardType, SaleOperation } from "../state/types"

export type BudgetPriceItem = {
    paymentType: PaymentType
    price: number
}

export type SaleFilters = {
    currentBranchId?: string
    searchText?: string
    customerId?: string
    sellerId?: string
    dateFrom?: Date
    dateTo?: Date
    paymentTypeId?: string
    paymentStatus?: PaymentStatus
    deliveryStatus?: DeliveryStatus
    latePayment?: string
    saleStatus?: 'active' | 'cancelled'
}

export type HoardFilters = {
    currentBranchId?: string
    searchText?: string
    deliveryStatus?: DeliveryStatus
    paymentStatus?: PaymentStatus
    sellerId?: string
    customerId?: string
    dateFrom?: Date
    dateTo?: Date
    type?: HoardType
    hoardStatus?: HoardStatusFilter
}

// Un acopio cerrado queda con estado de entrega "Entregado"
export enum HoardStatusFilter {
    ACTIVE = 'active',
    CLOSED = 'closed'
}

export type CreditDebtFilters = {
    customerId?: string
}

export type CustomerDebt = {
    customerId: string
    customer?: Customer
    creditAccountDebt: number
    otherDebt: number
    totalDebt: number
}

export type CustomersDebtResult = {
    customersDebt: CustomerDebt[]
    skippedOperations: SaleOperation[]
}
